import { Button, Card, CardContent, CardHeader, Divider } from "@mui/material";
import { colors, formatCurrency } from "common";
import { H6, Paragraph, Tiny } from "components/Typography";
import useResolution from "hooks/useResolution";
import { AffiliateOrder } from "modules/user-affiliate/types";
import { FC, memo, useState } from "react";

type Props = { order?: AffiliateOrder };

const Component: FC<Props> = ({ order }) => {
  const { isMobile } = useResolution();
  const [showMore, setShowMore] = useState(false);

  return (
    <Card elevation={2} key={order?.order_no} sx={{ mb: 2 }}>
      <CardHeader
        title={
          <H6 style={{ color: colors.success }}>
            🪙 Affiliate Earnings: +
            {formatCurrency(order?.affiliate_earning_amount)}
          </H6>
        }
        subheader={
          <div>
            <Tiny style={{ display: "block" }}>
              Transaction Amount:{" "}
              {formatCurrency(
                parseFloat(order?.total_amount_paid?.replace(/,/g, ""))
              )}{" "}
              | Discounted:{" "}
              {formatCurrency(
                parseFloat(order?.received_discount?.replace(/,/g, ""))
              )}{" "}
              | Percentage: {order?.affiliate_earning_percent}
            </Tiny>
            <Tiny style={{ display: "block" }}>
              Transaction Date: {order?.transaction_date}
            </Tiny>
          </div>
        }
      />
      <Divider />
      <CardContent>
        <H6>
          👤 Customer: {order?.customer_name} | {order?.order_no}
        </H6>
        <Divider sx={{ my: 1 }} />

        <div
          style={{
            position: "relative",
            maxHeight: showMore ? "none" : isMobile ? "5em" : "3em",
            overflow: "hidden",
          }}
        >
          <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
            {order?.products.map((product, index) => (
              <li key={index} style={{ listStyleType: "disc" }}>
                {product}
              </li>
            ))}
          </ul>

          {!showMore && order?.products?.length > 1 ? (
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "3em",
                background:
                  "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                paddingBottom: "0.5em",
              }}
            >
              <button
                onClick={() => setShowMore(true)}
                style={{
                  border: "none",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "999px",
                  padding: "0.3em 1em",
                  cursor: "pointer",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                }}
              >
                See more ▼
              </button>
            </div>
          ) : null}

          {showMore && order?.products?.length > 1 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "0.5em",
              }}
            >
              <button
                onClick={() => setShowMore(false)}
                style={{
                  border: "none",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "999px",
                  padding: "0.3em 1em",
                  marginBottom: "0.3em",
                  cursor: "pointer",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                }}
              >
                See less ▲
              </button>
            </div>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
};

export const AffiliateInfoCard = memo(Component);
